export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11572.7043c11a.jpg";